import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { PrivilegesService } from '@bayclubs/court-booking-employee-api';
import { BcPrivilegesProviderService } from '@bayclubs/employee-auth';

@Injectable({
    providedIn: 'root',
})
export class OfficePrivilegesProviderService extends BcPrivilegesProviderService {
    public scope = 'CourtBooking';

    constructor(private privilegesService: PrivilegesService) {
        super();
    }

    getPrivileges(): Observable<any> {
        return this.privilegesService.api10PrivilegesGet();
    }
}
